// esicEmployee.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    createEsicEmployee,
    fetchEsicEmployees,
    fetchEsicEmployeeById,
    updateEsicEmployee,
    deleteEsicEmployee,
} from './employeemappingAction';
import { EsicEmployeeState, ESICEmployee } from './employeemappingType';

const initialState: EsicEmployeeState = {
    records: [],
    loading: 'idle',
    error: null,
};

const esicEmployeeSlice = createSlice({
    name: 'esicEmployee',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // --- createEsicEmployee ---
        builder
            .addCase(createEsicEmployee.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })

            .addCase(createEsicEmployee.fulfilled, (state, action: PayloadAction<ESICEmployee>) => {
                state.loading = 'succeeded';
                state.records.unshift(action.payload);
            })
            .addCase(createEsicEmployee.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            });

        // --- fetchEsicEmployees ---
        builder
            .addCase(fetchEsicEmployees.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            .addCase(fetchEsicEmployees.fulfilled, (state, action) => {
                state.records = action.payload || [];
                state.loading = false;
            })

            .addCase(fetchEsicEmployees.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            });

        // --- fetchEsicEmployeeById ---
        builder
            .addCase(fetchEsicEmployeeById.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            .addCase(fetchEsicEmployeeById.fulfilled, (state, action: PayloadAction<ESICEmployee>) => {
                state.loading = 'succeeded';
                const index = state.records.findIndex(rec => rec.esic_emp_id === action.payload.esic_emp_id);
                if (index !== -1) {
                    state.records[index] = action.payload;
                } else {
                    state.records.push(action.payload);
                }
            })
            .addCase(fetchEsicEmployeeById.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            });

        // --- updateEsicEmployee ---
        builder
            .addCase(updateEsicEmployee.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            // ✅ Action payload is now the full ESICEmployee object
            .addCase(updateEsicEmployee.fulfilled, (state, action: PayloadAction<ESICEmployee>) => {
                state.loading = 'succeeded';
                const index = state.records.findIndex(rec => rec.esic_emp_id === action.payload.esic_emp_id);
                if (index !== -1) {
                    state.records[index] = action.payload;
                }
            })
            .addCase(updateEsicEmployee.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            });

        // --- deleteEsicEmployee ---
        builder
            .addCase(deleteEsicEmployee.pending, (state) => {
                state.loading = 'pending';
                state.error = null;
            })
            .addCase(deleteEsicEmployee.fulfilled, (state, action: PayloadAction<number>) => {
                state.loading = 'succeeded';
                state.records = state.records.filter(record => record.esic_emp_id !== action.payload);
            })
            .addCase(deleteEsicEmployee.rejected, (state, action) => {
                state.loading = 'failed';
                state.error = action.payload as string;
            });
    },
});

export default esicEmployeeSlice.reducer;